"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redfast = void 0;
const core_1 = require("../../core");
const Actions_1 = require("./Actions");
exports.Redfast = {
    createActions: (config) => {
        if (typeof window !== undefined) {
            window.FoxRedfast = new Actions_1.RedfastActions(config);
            (0, core_1.logInfo)("Redfast SDK", "Actions Initialized");
        }
    },
};
//# sourceMappingURL=index.js.map